<ng-container *ngFor="let notification of notifications; first as isFirst; last as isLast">
  <fcom-notification
    *ngIf="notification.show"
    [theme]="notification.theme || NotificationTheme.INFO"
    [layout]="notification.layout || NotificationLayout.BLOCK"
    [iconName]="notification.iconName || SvgLibraryIcon.INFO"
    [linkText]="
      notification.clickFn || notification.linkTarget
        ? ('MMB.notifications.' + notification.translationKey + '.linkText' | finLocalization)
        : undefined
    "
    [linkOpenInNewWindow]="notification.linkOpenInNewWindow || false"
    [linkUrl]="notification.linkTarget || undefined"
    (linkClick)="notification.clickFn ? notification.clickFn($event) : undefined"
    class="block"
    [class.mr-xxsmall-b]="!isLast"
  >
    <span *ngIf="notification.hasInnerHTML; else plainText">
      <span
        [innerHTML]="
          'MMB.notifications.' + notification.translationKey + '.text' | finLocalization: notification.replace || {}
        "
      ></span>
    </span>

    <ng-template #plainText>
      {{ 'MMB.notifications.' + notification.translationKey + '.text' | finLocalization: notification.replace || {} }}
    </ng-template>
  </fcom-notification>
</ng-container>
